// Toy Finder:遊び方・噛む強さ・予算を選ぶと、商品タグと価格で絞り込んでおすすめを出す
// タグの形:「play:sniff」「chew:gentle」。商品は /collections/all/products.json から読む
if (!customElements.get('gift-finder')) {
  customElements.define(
    'gift-finder',
    class GiftFinder extends HTMLElement {
      connectedCallback() {
        this.answers = {};
        this.steps = [...this.querySelectorAll('.gift-finder__step')];
        this.budgets = (this.dataset.budgets || '').split(',').map(Number);
        this.submit = this.querySelector('.gift-finder__submit');
        this.reset = this.querySelector('.gift-finder__reset');
        this.result = this.querySelector('.gift-finder__result');

        this.steps.forEach((step) => {
          step.querySelectorAll('.gift-finder__option').forEach((btn) => {
            btn.setAttribute('aria-pressed', 'false');
            btn.addEventListener('click', () => {
              step.querySelectorAll('.gift-finder__option').forEach((b) => b.setAttribute('aria-pressed', 'false'));
              btn.setAttribute('aria-pressed', 'true');
              this.answers[step.dataset.key] = btn.dataset.value;
              this.submit.disabled = Object.keys(this.answers).length !== this.steps.length;
            });
          });
        });

        this.submit.addEventListener('click', () => this.recommend());
        this.reset.addEventListener('click', () => {
          this.answers = {};
          this.querySelectorAll('.gift-finder__option').forEach((b) => b.setAttribute('aria-pressed', 'false'));
          this.submit.disabled = true;
          this.reset.hidden = true;
          this.result.innerHTML = '';
        });
      }

      async loadProducts() {
        if (this.products) return this.products;
        const res = await fetch(`${this.dataset.allUrl}/products.json?limit=250`);
        const data = await res.json();
        this.products = data.products || [];
        return this.products;
      }

      escape(text) {
        return String(text).replace(/[&"'<>]/g, (c) => `&#${c.charCodeAt(0)};`);
      }

      async recommend() {
        this.reset.hidden = false;

        if (this.answers.chew === 'heavy') {
          this.result.innerHTML = `
            <p class="gift-finder__message">${this.escape(this.dataset.heavyMessage || '')}</p>
            <div class="gift-finder__more"><a class="button button--secondary" href="${this.dataset.allUrl}">Browse the market</a></div>`;
          return;
        }

        this.submit.disabled = true;
        this.result.innerHTML = '<p class="gift-finder__message">Finding toys for your dog…</p>';
        let products = [];
        try {
          products = await this.loadProducts();
        } catch (e) {
          products = [];
        }

        const { play, chew, budget } = this.answers;
        const limit = budget === '0' ? Infinity : this.budgets[Number(budget) - 1];
        const chewOk = chew === 'gentle' ? ['chew:gentle'] : ['chew:gentle', 'chew:moderate'];
        const scored = products
          .map((p) => {
            const tags = Array.isArray(p.tags) ? p.tags : String(p.tags || '').split(',').map((t) => t.trim());
            const price = Math.min(...p.variants.map((v) => parseFloat(v.price)));
            if (tags.includes('bundle')) return { ok: false };
            const hasChewTag = tags.some((t) => t.startsWith('chew:'));
            const chewMatch = !hasChewTag || tags.some((t) => chewOk.includes(t));
            let score = 0;
            if (tags.includes(`play:${play}`)) score += 2;
            if (hasChewTag && chewMatch) score += 1;
            const varies = p.variants.some((v) => parseFloat(v.price) !== price);
            return { p, price, varies, score, ok: chewMatch && !(price > limit) };
          })
          .filter((x) => x.ok && x.score > 0)
          .sort((a, b) => b.score - a.score || a.price - b.price)
          .slice(0, 4);

        this.submit.disabled = false;

        if (scored.length === 0) {
          this.result.innerHTML = `
            <p class="gift-finder__message">We couldn't find a perfect match right now. Try a different budget or play style, or browse the whole market.</p>
            <div class="gift-finder__more"><a class="button" href="${this.dataset.allUrl}">Browse the market</a></div>`;
          return;
        }

        const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        const fmt = new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' });
        const items = scored
          .map(({ p, price, varies }) => {
            const src = p.images && p.images[0] ? p.images[0].src : '';
            const img = src ? `<img src="${src}${src.includes('?') ? '&' : '?'}width=500" alt="" loading="lazy">` : '<img alt="">';
            return `<li><a class="gift-finder__card" href="${root}products/${p.handle}">${img}
              <div class="gift-finder__card-body"><p class="gift-finder__card-title">${this.escape(p.title)}</p>
              <p class="gift-finder__card-price">${varies ? 'From ' : ''}${fmt.format(price)}</p></div></a></li>`;
          })
          .join('');
        this.result.innerHTML = `
          <p class="gift-finder__message">Picked for your dog</p>
          <ul class="gift-finder__grid">${items}</ul>
          <p class="gift-finder__message gift-finder__note">Mix and match: orders of $50 or more ship free in the US.</p>
          <div class="gift-finder__more"><a class="button button--secondary" href="${this.dataset.allUrl}">See all toys</a></div>`;
        this.result.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  );
}
